import { render, staticRenderFns } from "./color-picker-field.vue?vue&type=template&id=215deebc&"
import script from "./color-picker-field.vue?vue&type=script&lang=js&"
export * from "./color-picker-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports